import * as yup from 'yup'
import { inputPriceRegExp } from 'utils/regExp'

export const validationSchema = (coachFacilities = [], paymentAccounts = []) =>
  yup.object().shape({
    title: yup
      .string()
      .min(1)
      .required(),
    maxAttendance: yup
      .number()
      .nullable()
      .transform((value, originalValue) => {
        return String(originalValue).trim() === '' ? null : value
      }),
    unlisted: yup.boolean().required(),
    price: yup
      .string()
      .matches(inputPriceRegExp, 'Please enter a valid price')
      .required('This field is required'),
    paymentAccountId: yup
      .string()
      .oneOf(['', ...paymentAccounts.map(pa => pa.id)])
      .nullable(),
    locationId: yup
      .string()
      .required()
      .oneOf(coachFacilities.map(f => f.id)),
    tags: yup
      .array()
      .required()
      .min(1)
      .max(5),
    externalRegistrationUrl: yup.string().url('Please enter a valid URL'),
    featuredImageUrl: yup.string().required(),
    sessions: yup
      .array()
      .min(1, 'Group events must have at least one date/time occurrence')
      .required()
      .of(
        yup.object().shape({
          startDate: yup.date().required(),
          startTime: yup
            .date()
            .typeError('Start time must be a valid time')
            .label('Start Time')
            .required(),
          endTime: yup
            .date()
            .typeError('End time must be a valid time')
            .label('End Time')
            .min(yup.ref('startTime'), 'End time should be after start time')
            .required(),
        }),
      ),
    accessCode: yup.string().matches(/^[a-z0-9]+$/i, {
      message: 'Access codes must consist of numbers and letters only',
      excludeEmptyString: true.valueOf,
    }),
  })
